export function workspaceDestination(onboardingCompleted: boolean) {
  return onboardingCompleted ? '/calendar' : '/onboarding'
}

export function resolveOnboardingCompleted(
  onboardingCompleted: boolean | undefined,
  workspaceItemCount: number,
) {
  if (typeof onboardingCompleted === 'boolean') return onboardingCompleted
  return workspaceItemCount > 0
}
